<app-spoken-language-input />
<app-sign-writing />
<app-signed-language-output />
